import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AssetPhysicalConnectionComponent from './AssetPhysicalConnectionComponent';
import * as actions from './actions';
import { getModel } from './selectors';
import { withErrorBoundaryTrigger } from 'sharedComponents/ErrorBoundary';
import './style.scss';

const AssetPhysicalConnectionContainer = (props) => {
    const { asset, actions: { getPhysicalConnections, clearPhysicalConnections } } = props;

    useEffect(() => {
        if (asset?.id) {
            getPhysicalConnections(asset.id);
        }
        return () => {
            clearPhysicalConnections();
        };
    }, [asset?.id, getPhysicalConnections, clearPhysicalConnections]);

    return <AssetPhysicalConnectionComponent {...props} />;
};


const mapStateToProps = (state) => ({
    model: getModel(state)
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch)
});

const AssetPhysicalConnectionContainerWithTrigger = withErrorBoundaryTrigger(AssetPhysicalConnectionContainer);

const AssetPhysicalConnectionContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(AssetPhysicalConnectionContainerWithTrigger);

AssetPhysicalConnectionContainer.propTypes = {
    asset: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }),
    actions: PropTypes.shape({
        getPhysicalConnections: PropTypes.func,
        clearPhysicalConnections: PropTypes.func
    })
};

export default AssetPhysicalConnectionContainerConn;
